module.exports = __webpack_public_path__ + "static/media/wmsui32_1001.b35ecca2.ico";